import React, { Component } from "react";
import { loggedIn, getProfile, logout } from "../api/jwt";

export default function withAuth(AuthComponent) {
  return class AuthWrapped extends Component {
    constructor() {
      super();
      this.state = {
        user: null
      };
    }

    componentWillMount() {
      if (!loggedIn()) {
        this.props.history.replace("/");
      } else {
        try {
          const profile = getProfile();
          this.setState({
            user: profile
          });
        } catch (err) {
          logout();
          this.props.history.replace("/");
        }
      }
    }

    render() {
      if (this.state.user) {
        return (
          <AuthComponent
            history={this.props.history}
            dispatch={this.props.dispatch}
            user={this.state.user}
            match={this.props.match}
          />
        );
      } else {
        return null;
      }
    }
  };
}
